import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-buildings-03',
  standalone: true,
  templateUrl: '../../assets/buildings-03.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamBuildings03Icon {}
